export default __webpack_public_path__ + "static/media/fd3.6c44833e.jpg";